import { calculateTotalHoursWithConsumptionFactor } from "components/timesheet/utils";
import {  fetchTimesheetSpentHoursForMilestone } from "components/milestone/stats/spent/api";

import { useQuery } from "@tanstack/react-query";
import { milestoneKeys } from "components/milestone/queries";

export function useMilestoneSpentHours(id, dateRange) {
  return useQuery({
    queryFn: () => fetchTimesheetSpentHoursForMilestone({ id, dateRange }),
    queryKey: milestoneKeys.allLoggedHours(id, dateRange),
    select: (data) =>
      calculateTotalHoursWithConsumptionFactor(data, "logged_hours"),
    enabled: !!id,
  });
}
